<template>
  <div class="content">
    <div style="margin-top: 5px">
      <div class="button-click-left">
        <!-- chọn trạng thái -->
        <el-select
            class="button-left-status"
            v-model="dataSearch.status"
            @change="searchHeaderMethod()"
            placeholder="Trạng thái"
        >
          <el-option
              v-for="item in kidStatusList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
          ></el-option>
        </el-select>

        <!-- chọn khối -->
        <el-select
            v-if="this.getAppTypeUserLogin === 'plus'"
            class="button-left-class"
            clearable
            v-model="dataSearch.idGrade"
            @change="changeGradeMethod"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            class="button-left-class"
            filterable
            :clearable="this.getAppTypeUserLogin === 'plus'"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="searchHeaderMethod"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>

        <!-- nhập ô tìm kiếm -->
        <el-input
            class="button-left-class"
            style="width: 280px"
            placeholder="Nhập tên, biệt danh, SĐT"
            clearable
            v-model="dataSearch.nameOrPhone"
            @clear="searchHeaderMethod()"
            @keyup.enter.native="searchHeaderMethod()"
        >
          <template #append>
            <el-button
                icon="el-icon-search"
                @click="searchHeaderMethod()"
            ></el-button>
          </template>
        </el-input>
      </div>
    </div>
    <div style="margin-top: 20px">
      <el-col :span="7">
        <div class="content-line-1 color-3">
          <i class="el-icon-document-checked"></i>
          Tổng số học sinh đang sử dụng thanh toán trực tuyến: {{ numberStudentOnlinePayment }}
        </div>
      </el-col>
      <el-col :span="7" :offset="1">
        <div class="content-line-1 color-1">
          <i class="el-icon-document-checked"></i>
          Tổng số học sinh giới hạn sử dụng thanh toán trực tuyến: {{ totalLimitConfigSchool }}
        </div>
      </el-col>
      <el-col :span="7" :offset="1">
        <div class="content-line-1 color-4">
          <el-checkbox
              disabled
              v-model="onlinePaymentLimit"
          ></el-checkbox>
          <span style="margin-left: 10px"> Không cho phép vượt giới hạn</span>
        </div>
      </el-col>
    </div>
    <!-- nội dung thông tin chính -->
    <div class="table-content row-data" style="margin-top: 80px">
      <span v-if="multipleSelection.length > 0">Đã chọn: {{ multipleSelection.length }}</span>
      <el-table
          ref="multipleTable"
          :empty-text="textTable"
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          :data="studentList"
          highlight-current-row
          :cell-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="$tableMaxHeight"
          border
      >
        <el-table-column
            type="selection"
            fixed
            align="center"
            width="50"
        ></el-table-column>
        <el-table-column
            type="index"
            fixed
            align="center"
            label="STT"
            width="50"
        ></el-table-column>
        <el-table-column
            fixed
            align="center"
            label="Mã HS"
            prop="kidCode"
            width="120"
        ></el-table-column>
        <el-table-column min-width="170" fixed label="Họ tên">
          <template v-slot:default="scope">
            {{ scope.row.fullName }}
          </template>
        </el-table-column>
        <el-table-column
            label="Biệt danh"
            prop="nickName"
            min-width="100"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="maClass.className"
            min-width="130"
            label="Lớp"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="gender"
            min-width="80"
            label="Giới tính"
            align="center"
        ></el-table-column>

        <el-table-column prop="enableOnlinePayment" width="200" label="Thanh toán trực tuyến" align="center">
          <template v-slot:default="scope">
            <el-checkbox
                :disabled="checkLimitOnlinePayment"
                v-model="scope.row.enableOnlinePayment"
                @change="handleEnableOnlinePayment(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex">
        <el-col :span="22" style=" margin: 15px 0">
          <div class="container_nav_page">
            <el-pagination
                background
                :current-page="pageNumber"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="$pageListDefaultUser"
                :page-size="maxPageItem"
                :layout="$pageLayoutDefault"
                :total="pageTotal"
            ></el-pagination>
          </div>
        </el-col>
        <el-col :span="2">
          <div style="float: right; margin: 15px 0">
            <el-dropdown @command="handleCommand">
              <el-button class="button-bottom" type="success">
                Tác vụ
                <i class="el-icon-caret-bottom"/>
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item command="enableOnlinePayment"
                >Cho phép thanh toán trực tuyến
                </el-dropdown-item
                >
                <el-dropdown-item command="disableOnlinePayment"
                >Hủy thanh toán trực tuyến
                </el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <div style="margin-bottom: 20px">
        <span style="font-size: 20px; font-weight: bold">Lịch sử thay đổi vượt hạn mức cho phép</span>
      </div>

      <!-- chọn trạng thời gian -->
      <el-row type="flex">
        <el-col :span="4">
          <el-date-picker
              v-model="month"
              :clearable="false"
              type="month"
              @change="searchByPropertiesHistory"
              placeholder="Chọn tháng"
              value-format="M-yyyy"
              format="MM-yyyy"
              :time-arrow-control="false"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="10" style="margin-top: 10px">
          <i class="el-icon-document-checked"></i>
          <span style="font-weight: bold">
             Tổng số học sinh sử dụng lớn nhất khi thay đổi được ghi nhận trong tháng: {{ maxValueChange }}
            </span>
        </el-col>
      </el-row>
      <!-- nội dung thông tin chính -->
      <div class="table-content row-data" style="margin-top: 20px">
        <el-table
            ref="multipleTable"
            :empty-text="textTable"
            v-loading="loadingDataHistory"
            :element-loading-text="$tableLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255, 0)"
            :data="studentListChange"
            highlight-current-row
            :cell-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionChange"
            :max-height="$tableMaxHeight"
            border
        >
          <el-table-column
              type="index"
              fixed
              align="center"
              label="STT"
              width="50"
          ></el-table-column>
          <el-table-column
              prop="transactionDate"
              label="Thời gian thay đổi"
              width="300"
              align="center">
            <template #default="{ row }">
              {{ formatDate(row.createdDate) }}
            </template>
          </el-table-column>
          <el-table-column
              label="Tổng số học sinh thay đổi gần nhất được ghi nhận"
              prop="numberStudentChange"
              min-width="150"
              align="center"
          >
            <template v-slot="scope">
            <span
                style="color: #00a1ff; cursor: pointer;"
                @click="handleClickShowStudents(scope.row.id, 'change')"
            >
              {{ scope.row.numberStudentChange }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
              label="Tổng số học sinh đang sử dụng được ghi nhận khi thay đổi"
              prop="sumNumberStudentChangeUser"
              min-width="150"
              align="center"
          >
            <template v-slot="scope">
            <span
                style="color: #00a1ff; cursor: pointer;"
                @click="handleClickShowStudents(scope.row.id, 'all')"
            >
              {{ scope.row.sumNumberStudentChangeUser }}
            </span>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex">
          <el-col :span="22" style=" margin: 15px 0">
            <div class="container_nav_page">
              <el-pagination
                  background
                  :current-page="pageNumber2"
                  @size-change="handleSizeChange2"
                  @current-change="handleCurrentChange2"
                  :page-sizes="$pageListDefaultUser"
                  :page-size="maxPageItem2"
                  :layout="$pageLayoutDefault"
                  :total="pageTotal2"
              ></el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <StudentChangeOnlinePaymentDialog
          :isStudentChangeOnlinePaymentDialog="isStudentChangeOnlinePaymentDialog"
          :type="type"
          :idHistory="idHistory"
          :typeUser="typeUser"
          @closeDialog="closeStudentChangeOnlinePaymentDialog"
      />
    </div>
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import StudentService from "@/services/StudentService";
import {kidStatusList, loginStatusList} from "@/constant/listCommon";
import {mapState} from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import sePayConnectionService from "@/services/SePayConnectionService";
import StudentChangeOnlinePaymentDialog from "@/views/sepay/dialog/StudentChangeOnlinePaymentDialog.vue";

export default {
  components: {StudentChangeOnlinePaymentDialog},
  data() {
    return {
      loadingData: true,
      loadingDataHistory: true,
      textTable: "",
      pageTotal: this.$pageTotalDefault,
      maxPageItem: this.$pageSizeDefaultNew,
      pageNumber: 1,
      pageTotal2: this.$pageTotalDefault,
      maxPageItem2: this.$pageSizeDefaultNew,
      pageNumber2: 1,
      multipleSelection: [],
      loadingButton: false,
      fullscreenLoading: false,
      loading: "",
      dataSearch: {
        loginStatus: "",
        status: "STUDYING",
        idGrade: "",
        idClass: "",
        nameOrPhone: "",
        type: "startDate",
        dateList: [],
      },
      loginStatusList,
      kidStatusList,
      listClassSelect: [],
      numberStudentOnlinePayment: 0,
      totalLimitConfigSchool: 0,
      onlinePaymentLimit: false,
      studentListChange: [],
      maxValueChange: 0,
      month: this.getCurrentMonth(),
      isStudentChangeOnlinePaymentDialog: false,
      type: "",
      idHistory: 0,
      typeUser: "plus",
    };
  },
  created() {
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
      this.$store.dispatch('classStore/fetchDataClassListCommon');
    }
    if (this.getAppTypeUserLogin === "teacher") {
      this.$store.dispatch('classStore/fetchDataClassInTeacher')
    }
    this.searchByPropertiesHistory()
  },

  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade);
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      } else return this.classListCommon
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    checkLimitOnlinePayment() {
      return this.numberStudentOnlinePayment >= this.totalLimitConfigSchool && this.onlinePaymentLimit === true;
    }
  },
  watch: {
    gradeOfSchoolList: {
      immediate: true,
      handler(newVal) {
        if (newVal.length > 0 && this.getAppTypeUserLogin === "plus") {
          this.getIdGrade();
        }
      },
    },
    classList: {
      handler(newVal) {
        if (newVal.length > 0 && this.getAppTypeUserLogin === "teacher") {
          this.getIdClassInTeacher();
        }
      },
    }
  },

  methods: {
    checkPermission,
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    getCurrentMonth() {
      const now = new Date();
      const month = now.getMonth() + 1; // getMonth() trả 0-11
      const year = now.getFullYear();
      return `${month}-${year}`; // định dạng "M-yyyy"
    },
    // select rows
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },


    async handleEnableOnlinePayment(row) {
      const sum = this.numberStudentOnlinePayment + 1;

      const confirm = async (message, options = {}) => {
        try {
          await this.$confirm(message, "Thông báo!", {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
            ...options,
          });
          return true;
        } catch (e) {
          return false;
        }
      };

      const updateAndNotify = async () => {
        try {
          await StudentService.updateStatusOnlinePayment(row.id, row.enableOnlinePayment);
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
          await this.searchByProperties();
          await this.searchByPropertiesHistory();
        } catch (error) {
          console.log(error);
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
        }
      };

      if (row.enableOnlinePayment === true) {
        if (this.onlinePaymentLimit === true) {
          if (sum > this.totalLimitConfigSchool) {
            NotifyMessage.leftCornerNotificationError("Vượt giới hạn cho phép");
            return;
          }

          const confirmed = await confirm(
              "Bạn có chắc chắn bật thanh toán trực tuyến cho học sinh đã chọn?"
          );
          if (confirmed) {
            await updateAndNotify();
          }
        } else {
          if (sum > this.totalLimitConfigSchool) {
            const confirmed = await confirm(
                "⚠️ <strong>Cảnh báo vượt quá hạn mức!</strong><br/>Bạn có chắc chắn bật thanh toán trực tuyến cho học sinh đã chọn?",
                {
                  dangerouslyUseHTMLString: true,
                  type: "warning",
                }
            );
            if (confirmed) {
              await updateAndNotify();
            }
          } else {
            const confirmed = await confirm(
                "Bạn có chắc chắn bật thanh toán trực tuyến cho học sinh đã chọn?"
            );
            if (confirmed) {
              await updateAndNotify();
            }
          }
        }
      } else {
        const confirmed = await confirm(
            "Bạn có chắc chắn tắt thanh toán trực tuyến cho học sinh đã chọn?"
        );
        if (confirmed) {
          try {
            await StudentService.updateStatusOnlinePayment(row.id, row.enableOnlinePayment);
            NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
            await this.searchByProperties();
            await this.searchByPropertiesHistory();
          } catch (error) {
            console.log(error);
            NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
          }
        }
      }
    },


    // click chọn số bản ghi trên 1 trang
    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.searchByProperties();
    },
    //click chọn số trang
    handleCurrentChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },
    // click chọn số bản ghi trên 1 trang
    handleSizeChange2(maxPageItem) {
      this.maxPageItem2 = maxPageItem;
      this.searchByPropertiesHistory();
    },
    //click chọn số trang
    handleCurrentChange2(pageNumber) {
      this.pageNumber2 = pageNumber;
      this.searchByPropertiesHistory();
    },
    searchHeaderMethod() {
      this.pageNumber = 1;
      this.searchByProperties();
    },
    async searchByProperties() {
      this.loadingData = true;
      await this.getInfoStudentOnlinePayment()
      StudentService.searchKids(
          this.pageNumber,
          this.maxPageItem,
          this.dataSearch.loginStatus,
          this.dataSearch.status,
          this.dataSearch.idGrade,
          this.dataSearch.idClass,
          this.dataSearch.nameOrPhone,
          this.dataSearch.type,
          this.dataSearch.dateList
      )
          .then((resp) => {
            if (this.getAppTypeUserLogin === "teacher") {
              this.studentList =
                  this.dataSearch.idClass !== "" ? resp.data.data.dataList : [];

            } else {
              this.studentList1 = resp.data.data.dataList;
              this.studentList = resp.data.data.dataList;
            }
            this.pageTotal = resp.data.data.total;
          })
          .catch((err) => {
            this.pageTotal = 1;
            this.studentList = [];
            console.log(err);
          })
          .finally(() => {
            if (this.studentList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    searchByPropertiesHistory() {
      this.loadingDataHistory = true;
      const [monthStr, yearStr] = this.month.split('-');
      const monthNumber = parseInt(monthStr);
      const yearNumber = parseInt(yearStr);
      sePayConnectionService.findHistoryChangeStudentOnlinePayment(monthNumber, yearNumber, this.maxPageItem2, this.pageNumber2)
          .then((resp) => {
            this.studentListChange = resp.data.data.historyChangeStudentOnlinePaymentResponseList;
            this.pageTotal2 = resp.data.data.total;
            this.maxValueChange = resp.data.data.maxValueChange;
          })
          .catch((err) => {
            this.pageTotal2 = 1;
            this.studentListChange = [];
            console.log(err);
          })
          .finally(() => {
            if (this.studentListChange.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingDataHistory = false;
          });
    },

    handleCommand(command) {
      if (command === "enableOnlinePayment") {
        this.activeOnlinePayment(true)
      } else if (command === "disableOnlinePayment") {
        this.activeOnlinePayment(false)
      }
    },
    async activeOnlinePayment(value) {
      const idList = this.multipleSelection.map((x) => x.id);

      if (idList.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có học sinh nào được chọn");
        return;
      }

      const sum = this.multipleSelection.length + this.numberStudentOnlinePayment;

      const confirm = async (message, options = {}) => {
        try {
          await this.$confirm(message, "Thông báo!", {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
            ...options,
          });
          return true;
        } catch (e) {
          return false;
        }
      };

      if (value === true) {
        if (this.onlinePaymentLimit === true) {
          if (sum > this.totalLimitConfigSchool) {
            NotifyMessage.leftCornerNotificationError("Vượt giới hạn cho phép");
            return;
          }

          const confirmed = await confirm("Bạn có chắc chắn bật thanh toán trực tuyến cho danh sách học sinh đã chọn?");
          if (confirmed) {
            await this.handleChangeStatusOnlinePayment(idList, value);
          }
        } else {
          if (sum > this.totalLimitConfigSchool) {
            const confirmed = await confirm(
                "⚠️ <strong>Cảnh báo vượt quá hạn mức!</strong><br/>Bạn có chắc chắn bật thanh toán trực tuyến cho danh sách học sinh đã chọn?",
                {
                  dangerouslyUseHTMLString: true,
                  type: "warning",
                }
            );
            if (confirmed) {
              await this.handleChangeStatusOnlinePayment(idList, value);
            }
          } else {
            const confirmed = await confirm("Bạn có chắc chắn bật thanh toán trực tuyến cho danh sách học sinh đã chọn?");
            if (confirmed) {
              await this.handleChangeStatusOnlinePayment(idList, value);
            }
          }
        }
      } else {
        const confirmed = await confirm("Bạn có chắc chắn tắt thanh toán trực tuyến cho danh sách học sinh đã chọn?");
        if (confirmed) {
          await this.handleChangeStatusOnlinePayment(idList, value);
        }
      }
    },

    async handleChangeStatusOnlinePayment(idList, value) {
      const data = {
        idKidList: idList,
        enableOnlinePayment: value
      };

      try {
        await StudentService.updateStatusOnlinePaymentByList(data);
        NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
        await this.searchByProperties();
        await this.searchByPropertiesHistory();
      } catch (error) {
        console.log(error);
        NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
      }
    },

    /**
     * Lấy cấu hình của company
     */
    async getInfoStudentOnlinePayment() {
      await sePayConnectionService.getInfoStudentOnlinePayment().then((resp) => {
        this.numberStudentOnlinePayment = resp.data.data.numberStudentOnlinePayment;
        this.totalLimitConfigSchool = resp.data.data.totalLimitConfigSchool;
        this.onlinePaymentLimit = resp.data.data.onlinePaymentLimit;
      })
    },
    /**
     * thay đổi khối
     */
    changeGradeMethod() {
      this.dataSearch.idClass = "";
      this.searchHeaderMethod();
    },
    getIdGrade() {
      this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
      this.searchByProperties();
    },
    getIdClassInTeacher() {
      this.dataSearch.idClass = this.classList.filter((x) => x.checked)[0].id;
      this.searchByProperties();
    },
    formatDate(iso) {
      const d = new Date(iso)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} `
          + ` - ${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
    },
    handleClickShowStudents(id, type) {
      this.idHistory = id
      this.type = type
      this.isStudentChangeOnlinePaymentDialog = true
    },
    closeStudentChangeOnlinePaymentDialog() {
      this.isStudentChangeOnlinePaymentDialog = false;
      this.searchByPropertiesHistory()
    }


  },
  beforeMount() {
    this.getSchoolConfigAddMethod()
  }
}

;
</script>

<style lang="scss" scoped>
/deep/ .el-pagination .el-select .el-input {
  width: 75px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

// /deep/.el-table td,
// /deep/.el-table th {
//   padding: 6px 0;
// }
/deep/ .el-table th > .cell {
  text-align: center !important;
}

/deep/ .el-table th.gutter {
  background-color: #78a5e7;
}

/deep/ .el-icon-loading:before {
  content: "\e6cf";
}

/deep/ .el-loading-spinner .el-loading-text {
  color: #606266;
  font-size: 15px;
}

/deep/ .el-loading-spinner {
  top: 67%;
  width: 100%;
  text-align: center;
  position: absolute;
}

// /deep/.el-table--scrollable-y .el-table__body-wrapper {
//   overflow-y: auto;
//   margin-top: -1px;
// }
/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

.click-fullname {
  border: none;
  padding: 0;
  color: blue;
}

.click-fullname:hover {
  color: blue;
  background: none;
}

.content {
  .row-data {
    margin-bottom: 20px;
  }

  .button-left-status {
    margin-right: 5px;
    width: 130px;
  }

  .button-left-class {
    margin-right: 5px;
    width: 150px;
  }

  .button-over {
    border-radius: 0;
    margin-left: 3px;
  }

  .button-click-left {
    display: inline-block;
  }

  .button-click {
    float: right;
  }

  .table-content {
    .el-table {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border: 1px solid #78a5e7;
    }
  }

  .paging-click {
    .el-pagination {
      text-align: right;
      margin: 30px 0;
    }
  }
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: rgb(95, 180, 74);
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.click-in-row {
  border: none;
  padding: 0;
  color: #3a3ace;
}

.click-in-row:hover {
  color: #fa03d9;
}

.handle-account {
  border: none;
  padding: 0;
  color: red;
}

.handle-account:hover {
  color: #fa03d9;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}

.content-line-1 {
  padding: 6px;
  margin-bottom: 5px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
}

.color-1 {
  background: #c694f9;
}

.color-2 {
  background: #6aa5e3;
}

.color-3 {
  background: #feb683;
}

.color-4 {
  background: #ef5b5b;
}
</style>
